/* edited.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./edited.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { N200 } from '@atlaskit/theme/colors';
var editedContentStyles = {
  root: "_syaz1wmz"
};
var Edited = function Edited(_ref) {
  var children = _ref.children,
    onFocus = _ref.onFocus,
    onMouseOver = _ref.onMouseOver;
  return /*#__PURE__*/React.createElement("span", {
    onFocus: onFocus,
    onMouseOver: onMouseOver,
    className: ax([editedContentStyles.root])
  }, children);
};
Edited.displayName = 'Edited';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Edited;